export default "//static.glanacion.com/v2/myaccount/images/planes-triple.png";